export const digitalizationWhiteList = [
    '8fffe24d-a571-47d0-ba13-6535d003eca7', // Nermeen ID STAGING
    'f501f1f3-7a1d-412a-9470-12ea3507804e', // Nermeen ID Prod
    '797edffd-d20c-4482-baaf-8e346d41bc9e', // Mai ID STAGING
    '887e8eed-8f6a-4323-8562-881893041146', // Mai ID Prod
    '30b50918-939c-46cf-807d-cceb322761d6', // Youssef mamdouh Prod
    'd8e76964-027a-47c9-ad3f-b87a2ce6f6d6', //Sameh Samir PROD
];
